import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'scientific-fib',
})

export default class ScientificFIB extends Vue {

    // ----------------------------------------------------
    // Properties

    @Prop()
    private content!: any;


    @Prop()
    private showCorrect!: boolean;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    private get answerObject() {
        return this.content.answerObject;
    }

    private answers: any = [];

    // ---------------------------------------------------------------
    // Hooks


    // --------------------------------------------------------------
    // Methods

    private parseAnswerObject() {
        const component = this;
        const userAnswers: any = [];
        const userAnswer = component.userAnswer;
        if (userAnswer) {
            userAnswer.map((answer: any) => {
                const answerValue = answer.split(':');
                userAnswers.pushObject({
                category: answerValue[0],
                value: answerValue[1],
                });
            });
        }
        return userAnswers;
    }


    private parseAnswer() {
        const component = this;
        const answerDetails = component.question.answerDetails;
        const userAnswers = component.userAnswer
          ? component.userAnswer
          : '';
        const answerData = answerDetails.map((answerDetail: any) => {
          const input = '<input type=\'text\' value=\'\' disabled/>';

          const questionTextParts =
            answerDetail.answer_text.indexOf(input) !== -1
              ? answerDetail.answer_text.split(input)
              : answerDetail.answer_text.split(
                /\[](?!{)/,
              );
          const answerCategory = answerDetail.answer_category;
          if (userAnswers.length) {
            const userAnswerValue = userAnswers.filterBy(
              'category',
              answerDetail.answer_category,
            );
            const answersItems = userAnswerValue.map((answer: any) => {
              return {
                text: answer.value !== '' ? answer.value : ' ',
                class: 'answer',
              };
            });
            component.answers = answersItems;
          } else {
            const correctAnswer = answerDetail.correct_answer;
            const answersItems = correctAnswer.map((userAnswerObject: any) => {
              return {
                text: userAnswerObject,
                class: 'answer correct',
              };
            });
            component.answers = answersItems;
          }

          let sentences =
            Array.isArray(questionTextParts) &&
            questionTextParts.map((questionTextPart) => {
              return {
                text: questionTextPart,
                class: 'sentence',
              };
            });
          const answers = component.answers;
          sentences = answers && answers.length ? sentences : [];
          return component.mergeArrays(sentences, answers, answerCategory);
        });
        return answerData;
    }


   private mergeArrays(sentences: any, answers: any, answerCategory: any) {
        const mergeArrays: any = [];
        answers.forEach((item: any, index: any) => {
          mergeArrays.pushObject(sentences && sentences.get(index));
          mergeArrays.pushObject(item);
        });
        const answerByCategory = {
          category: answerCategory,
          value: mergeArrays,
        };
        return answerByCategory;
      }




}
